// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@bg/Overrides/Components/ProductPrice";
import { actionsStyles } from "@bg/Overrides/Widgets/ProductList/ProductListActions";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { productAddToCartButtonStyles } from "@bgs/Overrides/Components/ProductAddToCartButton";
import { productQuantityOrderedStyles } from "@bgs/Overrides/Components/ProductQuantityOrdered";
import { css } from "styled-components";

actionsStyles.productQuantityOrderedStyles = {
    wrapper: {
        css: css`
            ${productQuantityOrderedStyles.wrapper?.css}
            height: 100%;
        `,
    },
};

actionsStyles.qtyGridItem = {
    css: css`
        flex-basis: 40%;
        padding-right: 0;
        text-align: center;
        &&&.grid-qty {
            flex-grow: 1;
        }
        &&&& {
            button:first-child {
                padding: 0 8px;
            }
            button:last-child {
                padding: 0 8px;
            }
        }
        &&&& input {
            max-width: 100%;
            width: 100%;
        }
    `,
};

actionsStyles.addToCartButtonGridItem = {
    css: css`
        &&&.list-atc {
            flex-grow: 1;
        }

        &&&:not(.list-atc) {
            width: 90px;
            && button {
                min-width: 100%;
            }
        }
    `,
};

actionsStyles.addToCartButtonGridProps = {
    labelOverride: "Add To Cart",
    iconOnly: true,
};
actionsStyles.addToCartButtonListProps = {
    labelOverride: "Add To Cart",
    iconOnly: false,
    css: css`
        ${productAddToCartButtonStyles.asButton?.css}
        &&& {
            min-width: 100%;
        }
    `,
};

actionsStyles.priceStlye = {
    wrapper: {
        css: css`
            width: 100%;
            line-height: 17px;
        `,
    },
    price: {
        priceText: {
            size: fontConfig.fontSize.small,
            lineHeight: "17px",
            weight: fontConfig.weight.semiBold,
        },
        unitOfMeasureText: {
            size: fontConfig.fontSize.small,
            lineHeight: "17px",
            weight: fontConfig.weight.semiBold,
            transform: "uppercase",
        },
        nonStockText: {
            css: css`
                ${productPriceStyles.price?.nonStockText?.css}
                max-width: 235px;
            `,
        },
    },
};
